import { storageKeys, rules, gaEvents } from './loginNudgeConstants';

/*
  Helpers and utilities
 */

declare global {
  interface Window {
    ecGa: Function;
    ga: Function;
    ecGaEventsOnLoad: any[];
  }
}

const trackEvent = ({ eventAction = '', eventLabel = '' }) => {
  if (eventAction || eventLabel) {
    const event = { eventAction, eventLabel };
    if (window.ecGa && window.ga) {
      window.ecGa('trackEvent', event);
    } else {
      window.ecGaEventsOnLoad = window.ecGaEventsOnLoad || [];
      window.ecGaEventsOnLoad.push(event);
    }
  }
};

const returnLastValue = (arr) => arr.slice(-1)[0];

/*
  GA
 */

export const tracking = {
  dismiss: () => {
    trackEvent({
      eventAction: gaEvents.DISMISS.EVENT_ACTION,
      eventLabel: gaEvents.DISMISS.EVENT_LABEL,
    });
  },
  cta: () => {
    trackEvent({
      eventAction: gaEvents.CTA.EVENT_ACTION,
      eventLabel: gaEvents.CTA.EVENT_LABEL,
    });
  },
  focusIgnore: () => {
    trackEvent({
      eventAction: gaEvents.FOCUS_IGNORE.EVENT_ACTION,
      eventLabel: gaEvents.FOCUS_IGNORE.EVENT_LABEL,
    });
  },
};

/*
  Storage retrieval and setting logic
 */

export const lastDismissedStorage = {
  get: () => {
    try {
      return JSON.parse(localStorage.getItem(storageKeys.LAST_DISMISSED) || '') || [];
    } catch {
      return [];
    }
  },
  set: (value: any[]) => {
    try {
      localStorage.setItem(storageKeys.LAST_DISMISSED, JSON.stringify(value));
    } catch (e) {
      return e;
    }
  },
};

export const setLastDismissed = () => {
  const dates = lastDismissedStorage.get();
  const currentDate = new Date();

  if (dates.length > 0) {
    return lastDismissedStorage.set([returnLastValue(dates), currentDate]);
  }
  return lastDismissedStorage.set([currentDate]);
};

/*
  Logic checks for login nudge display/removal behaviour
 */

export const hasUserExceededPageViewLimit = () => window.history.length > rules.PAGE_VIEW_LIMIT;
